<div class="container-fluid">
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
        <h3 class="m-0 font-weight-bold" style="color: #1A355E;">HAREKET TABLOSU</h3>
        <ol class="breadcrumb ">
            <li class="breadcrumb-item active">Hareketler</li>
            <li class="breadcrumb-item active">Hareket Tablosu</li>
        </ol>
    </div>

    <div class="form-group row">
        <div class="col-2">
            <label for="txtInput01"><span class="badge badge-primary" style="font-size:1.2rem;">** Yıl</span></label>
            <p-inputNumber mode="decimal" inputId="year" [(ngModel)]="year" [min]="2021" [max]="2100"
                [useGrouping]="false" [showButtons]="true" (onInput)="loadDates()" (onKeyDown)="loadDates()">
            </p-inputNumber>
        </div>

        <div class="col-2">
            <label for="txtInput01"><span class="badge badge-primary" style="font-size:1.2rem;">** Ay</span></label>
            <p-inputNumber [(ngModel)]="month" [min]="1" [max]="12" [showButtons]="true" (onInput)="loadDates()"
                (onKeyDown)="loadDates()">
            </p-inputNumber>
        </div>

        <div class="col-1"></div>
        <div class="col-2">
            <label for="txtInput01"><span class="badge badge-primary" style="font-size:1.2rem;">** Başlangıç -
                    (Gün)</span></label>
            <p-inputNumber [(ngModel)]="startDay" [min]="1" [max]="31" [showButtons]="true">
            </p-inputNumber>
        </div>


        <div class="col-2">
            <label for="txtInput01"><span class="badge badge-primary" style="font-size:1.2rem;">** Bitiş -
                    (Gün)</span></label>
            <p-inputNumber [(ngModel)]="endDay" [min]="1" [max]="31" [showButtons]="true">
            </p-inputNumber>

        </div>

        <div style="padding-top:30px;" class="col-2">
            <button pButton type="button" class="p-button-lg p-button-help" label="Filtrele"
                (click)="getList()"></button>
        </div>

    </div>

    <div class="data-grid">
        <p-table #dt [value]="movements$ | async" [paginator]="true" [rows]="25" [showCurrentPageReport]="true"
            [(selection)]="selectedRecords" styleClass="p-datatable-sm" [rowHover]="true"
            currentPageReportTemplate="{totalRecords} veriden {first} - {last} gösteriliyor.." [globalFilterFields]="['projectName','customerName','serviceName','portalName','contractTypeName','serviceCode',
            'invoiceDate','serviceUnitPrice','numberOfTerminals','recordStatusName','currencyUnit']"
            [responsive]="true" [rowsPerPageOptions]="[5,10,25,50]">
            <ng-template pTemplate="caption">
                <button pButton type="button" label="Sipariş Oluştur" (click)="createOrder()"></button>
                <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()"
                    class="p-button-success p-mr-2" pTooltip="Dışa Aktar" tooltipPosition="bottom"
                    label="Dışa Aktar"></button>
                <div style="text-align: right">
                    <input style="float:right" type="text" pInputText size="50" placeholder="Ara"
                        (input)="applyFilterGlobal($event, 'contains')" style="width:auto">
                </div>

                <div class="text-center" *ngIf="loading">
                    <div class="spinner-grow text-primary" style="width: 3rem; height: 3rem;" role="status">
                    </div>
                    <div class="spinner-grow text-danger" style="width: 3rem; height: 3rem;" role="status">
                    </div>
                    <div class="spinner-grow text-secondary" style="width: 3rem; height: 3rem;" role="status">
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 3rem">
                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </th>
                    <th pSortableColumn="customerName" [width]="'13%'">Müşteri<p-sortIcon field="customerName">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="projectName" [width]="'12%'">Proje<p-sortIcon field="projectName">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="contractTypeName" [width]="'5%'">Tip<p-sortIcon field="contractTypeName">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="portalName" [width]="'5%'">Portal<p-sortIcon field="portalName">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="serviceCode" [width]="'8%'">Hizmet Kodu<p-sortIcon field="serviceCode">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="serviceName" [width]="'8%'">Hizmet<p-sortIcon field="serviceName">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="dealerName" [width]="'10%'">Bayi<p-sortIcon field="dealerName">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="serviceUnitPrice" [width]="'8%'">Birim Fiyatı<p-sortIcon
                            field="serviceUnitPrice">
                        </p-sortIcon>
                    </th>

                    <th pSortableColumn="invoiceDate" [width]="'10%'">Faturalama Tarihi<p-sortIcon field="invoiceDate">
                        </p-sortIcon>
                    </th>

                    <th pSortableColumn="notes" [width]="'7%'">Notlar<p-sortIcon field="notes">
                        </p-sortIcon>
                    </th>

                    <th pSortableColumn="numberOfTerminals" [width]="'8%'">Terminaller<p-sortIcon
                            field="numberOfTerminals">
                        </p-sortIcon>
                    </th>

                    <th pSortableColumn="recordStatusName" [width]="'7%'">Durum<p-sortIcon field="recordStatusName">
                        </p-sortIcon>
                    </th>
                </tr>

            </ng-template>
            <ng-template pTemplate="body" let-movements>
                <tr>
                    <td>
                        <p-tableCheckbox *ngIf="!movements.recordStatus" [value]="movements"></p-tableCheckbox>
                        <button *ngIf="movements.recordStatus" pButton pRipple type="button" icon="pi pi-refresh"
                            class="p-button-rounded p-button-warning" pTooltip="Siparişi Tekrar Oluştur"
                            tooltipPosition="bottom" (click)="repeat(movements)"></button>
                    </td>
                    <td>{{movements.customerName}}</td>
                    <td>{{movements.projectName}}</td>
                    <td>{{movements.contractTypeName}}</td>
                    <td>{{movements.portalName}}</td>
                    <td>{{movements.serviceCode}}</td>
                    <td>{{movements.serviceName}}</td>
                    <td>{{movements.dealerName}}</td>
                    <td>{{movements.serviceUnitPrice| number: '1.0'}} {{movements.currencyUnit}}</td>
                    <td>
                        <span class="badge badge-info" style="font-size: 1.1rem;">{{movements.invoiceDate | date
                            :"dd.MM.yyyy"}}</span>
                    </td>

                    <td>{{movements.notes}}</td>
                    <td> <span class="badge badge-dark"
                            style="font-size: 1.5rem;">{{movements.numberOfTerminals}}</span></td>
                    <td> <span class="badge badge-success"
                            style="font-size: 1.2rem;">{{movements.recordStatusName}}</span>
                    </td>
                </tr>
            </ng-template>
        </p-table>

    </div>
</div>


<p-dialog header="SİPARİŞ OLUŞTURMA" [(visible)]="displayModal" [modal]="true" [style]="{width: '50vw'}"
    [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <div style="text-align: center;" *ngIf="progress">
        <span class="badge badge-success" style="font-size: 1.5rem;">Siparişler oluşturuluyor. Lütfen
            bekleyiniz...</span>
        <p-progressBar [value]="value"></p-progressBar>
    </div>
    <ng-template pTemplate="footer">
    </ng-template>
</p-dialog>

<p-dialog header="SİPARİŞİ TEKRAR OLUŞTURMA" [(visible)]="repeatModal" [modal]="true" [style]="{width: '50vw'}"
    [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <p class="p-m-0">Sipariş Terkrar Oluşturulacak. Onaylıyor musunuz?</p>
    <ng-template pTemplate="footer">
        <p-button (click)="repeatModal=false" label="Vazgeç" styleClass="p-button-danger"></p-button>
        <p-button (click)="repeatSave()" label="Oluştur" styleClass="p-button-info"></p-button>
    </ng-template>
</p-dialog>

<p-dialog header="BAZI SİPARİŞLER OLUŞTURULAMADI. LÜTFEN LİSTENİZİ KONTROL EDİN. LOGODAN DÖNEN HATALAR :"
    [(visible)]="logoError" [modal]="true" [style]="{width: '50vw'}" [baseZIndex]="10000" [draggable]="false"
    [resizable]="false">
    <ng-template pTemplate="body">
        <textarea [(ngModel)]="logoErrorMessage" rows="20" readonly="true" style="width: 100%;"></textarea>
    </ng-template>
</p-dialog>